// Web pickers hand back a native File (which IS a Blob); using it avoids the
// fragile blob: URL fetch that intermittently throws "Failed to fetch" on
// mobile Chrome when the object URL is revoked under memory pressure.
export const assetToBlob = async (asset: {
  uri: string;
  file?: File;
}): Promise<Blob> => {
  if (asset.file) {
    return asset.file;
  }
  const response = await fetch(asset.uri);
  return response.blob();
};
